module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/acoustic-v2-9bdb3d79fdae12a581d29af83af8dc4a.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/acoustic-v2.svg
// module id = XZg+
// module chunks = 1 3 10 12 18